module.exports = {
	"config": {
		"siteTitle": "CKJ • Chris Jennings",
		"linkPrefix": "/ckj"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/ckj/src/ckj.github.io/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/ckj/src/ckj.github.io/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "about.js",
				"ext": "js",
				"name": "about",
				"extname": ".js",
				"basename": "about.js",
				"dirname": "",
				"stem": "about",
				"path": "about.js",
				"absolute": "/Users/ckj/src/ckj.github.io/about.js",
				"isAbsolute": false
			},
			"requirePath": "about.js",
			"path": "/about/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "code.js",
				"ext": "js",
				"name": "code",
				"extname": ".js",
				"basename": "code.js",
				"dirname": "",
				"stem": "code",
				"path": "code.js",
				"absolute": "/Users/ckj/src/ckj.github.io/code.js",
				"isAbsolute": false
			},
			"requirePath": "code.js",
			"path": "/code/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "coffee-react.cjsx",
				"ext": "cjsx",
				"name": "coffee-react",
				"extname": ".cjsx",
				"basename": "coffee-react.cjsx",
				"dirname": "",
				"stem": "coffee-react",
				"path": "coffee-react.cjsx",
				"absolute": "/Users/ckj/src/ckj.github.io/coffee-react.cjsx",
				"isAbsolute": false
			},
			"requirePath": "coffee-react.cjsx",
			"path": "/coffee-react/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "_header.js",
				"ext": "js",
				"name": "_header",
				"extname": ".js",
				"basename": "_header.js",
				"dirname": "components",
				"stem": "_header",
				"path": "components/_header.js",
				"absolute": "/Users/ckj/src/ckj.github.io/components/_header.js",
				"isAbsolute": false
			},
			"requirePath": "components/_header.js",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "shots.js",
				"ext": "js",
				"name": "shots",
				"extname": ".js",
				"basename": "shots.js",
				"dirname": "components",
				"stem": "shots",
				"path": "components/shots.js",
				"absolute": "/Users/ckj/src/ckj.github.io/components/shots.js",
				"isAbsolute": false
			},
			"requirePath": "components/shots.js",
			"path": "/components/shots/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "css-modules.js",
				"ext": "js",
				"name": "css-modules",
				"extname": ".js",
				"basename": "css-modules.js",
				"dirname": "",
				"stem": "css-modules",
				"path": "css-modules.js",
				"absolute": "/Users/ckj/src/ckj.github.io/css-modules.js",
				"isAbsolute": false
			},
			"requirePath": "css-modules.js",
			"path": "/css-modules/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "design.js",
				"ext": "js",
				"name": "design",
				"extname": ".js",
				"basename": "design.js",
				"dirname": "",
				"stem": "design",
				"path": "design.js",
				"absolute": "/Users/ckj/src/ckj.github.io/design.js",
				"isAbsolute": false
			},
			"requirePath": "design.js",
			"path": "/design/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "html.html",
				"ext": "html",
				"name": "html",
				"extname": ".html",
				"basename": "html.html",
				"dirname": "",
				"stem": "html",
				"path": "html.html",
				"absolute": "/Users/ckj/src/ckj.github.io/html.html",
				"isAbsolute": false
			},
			"requirePath": "html.html",
			"path": "/html/",
			"data": {
				"title": "HTML <u>still</u> ROCKS!",
				"body": "<!--\ntitle: HTML <u>still</u> ROCKS!\n-->\n<p>You can also author content in raw HTML if that's your flavoring. Gatsby handles\nthat just fine.</p>\n"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/ckj/src/ckj.github.io/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "json.json",
				"ext": "json",
				"name": "json",
				"extname": ".json",
				"basename": "json.json",
				"dirname": "",
				"stem": "json",
				"path": "json.json",
				"absolute": "/Users/ckj/src/ckj.github.io/json.json",
				"isAbsolute": false
			},
			"requirePath": "json.json",
			"path": "/json/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "less.js",
				"ext": "js",
				"name": "less",
				"extname": ".js",
				"basename": "less.js",
				"dirname": "",
				"stem": "less",
				"path": "less.js",
				"absolute": "/Users/ckj/src/ckj.github.io/less.js",
				"isAbsolute": false
			},
			"requirePath": "less.js",
			"path": "/less/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "markdown.md",
				"ext": "md",
				"name": "markdown",
				"extname": ".md",
				"basename": "markdown.md",
				"dirname": "",
				"stem": "markdown",
				"path": "markdown.md",
				"absolute": "/Users/ckj/src/ckj.github.io/markdown.md",
				"isAbsolute": false
			},
			"requirePath": "markdown.md",
			"path": "/markdown/",
			"data": {
				"title": "I'm a markdown file!"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "postcss.js",
				"ext": "js",
				"name": "postcss",
				"extname": ".js",
				"basename": "postcss.js",
				"dirname": "",
				"stem": "postcss",
				"path": "postcss.js",
				"absolute": "/Users/ckj/src/ckj.github.io/postcss.js",
				"isAbsolute": false
			},
			"requirePath": "postcss.js",
			"path": "/postcss/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "react.js",
				"ext": "js",
				"name": "react",
				"extname": ".js",
				"basename": "react.js",
				"dirname": "",
				"stem": "react",
				"path": "react.js",
				"absolute": "/Users/ckj/src/ckj.github.io/react.js",
				"isAbsolute": false
			},
			"requirePath": "react.js",
			"path": "/react/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "sass.js",
				"ext": "js",
				"name": "sass",
				"extname": ".js",
				"basename": "sass.js",
				"dirname": "",
				"stem": "sass",
				"path": "sass.js",
				"absolute": "/Users/ckj/src/ckj.github.io/sass.js",
				"isAbsolute": false
			},
			"requirePath": "sass.js",
			"path": "/sass/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "toml.toml",
				"ext": "toml",
				"name": "toml",
				"extname": ".toml",
				"basename": "toml.toml",
				"dirname": "",
				"stem": "toml",
				"path": "toml.toml",
				"absolute": "/Users/ckj/src/ckj.github.io/toml.toml",
				"isAbsolute": false
			},
			"requirePath": "toml.toml",
			"path": "/toml/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "tweets.js",
				"ext": "js",
				"name": "tweets",
				"extname": ".js",
				"basename": "tweets.js",
				"dirname": "",
				"stem": "tweets",
				"path": "tweets.js",
				"absolute": "/Users/ckj/src/ckj.github.io/tweets.js",
				"isAbsolute": false
			},
			"requirePath": "tweets.js",
			"path": "/tweets/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "yaml.yaml",
				"ext": "yaml",
				"name": "yaml",
				"extname": ".yaml",
				"basename": "yaml.yaml",
				"dirname": "",
				"stem": "yaml",
				"path": "yaml.yaml",
				"absolute": "/Users/ckj/src/ckj.github.io/yaml.yaml",
				"isAbsolute": false
			},
			"requirePath": "yaml.yaml",
			"path": "/yaml/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 382
// module chunks = 0